import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { Card } from '../ui/Card.jsx';
import { Skeleton } from '../ui/Skeleton.jsx';
import { fmt } from '../../lib/formatters.js';

/**
 * KPI card with an optional period-over-period delta.
 * delta: fraction (cur-prev)/prev, or null. goodWhen: 'up' | 'down' decides
 * whether an increase is shown as positive (green) or negative (amber).
 */
export function DeltaKpi({ label, value, sub, delta, goodWhen = 'up', loading }) {
  const hasDelta = delta != null && Number.isFinite(delta) && delta !== 0;
  const up = hasDelta && delta > 0;
  const improved = hasDelta && ((goodWhen === 'up' && delta > 0) || (goodWhen === 'down' && delta < 0));
  const tone = !hasDelta ? '' : improved ? 'text-success' : 'text-warning';
  const Arrow = up ? ArrowUpRight : ArrowDownRight;

  return (
    <Card className="p-5">
      <p className="text-xs font-medium text-ink-muted">{label}</p>
      {loading ? (
        <Skeleton className="mt-2 h-8 w-24" />
      ) : (
        <div className="mt-2 flex items-baseline gap-2">
          <p className="text-3xl font-semibold tracking-tight text-ink">{value}</p>
          {hasDelta && (
            <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${tone}`}>
              <Arrow className="h-3.5 w-3.5" aria-hidden="true" />{fmt.pct(Math.abs(delta))}
            </span>
          )}
        </div>
      )}
      {sub && !loading && <p className="mt-1 text-xs text-ink-muted">{sub}</p>}
    </Card>
  );
}
